import { ProfilePageTabId, ProfilePageTabsContainer } from '@colonist/clientforge';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { mountUIReactComponent } from '../ui_platform/mountUIReactComponent.tsx';
import { getProfilePopupElementId } from './UIViewProfilePopup.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UIProfileLinkController {
    mountReactSidebar() {
        const sidebarId = getProfilePopupElementId('profile_sidebar', this.isPopup);
        this.tabsView = mountUIReactComponent(sidebarId, ProfilePageTabsContainer);
        this.renderTabs();
    }
    renderTabs() {
        const isMobile = !this.isPopup && UIUtilsEjsVariables.isUserOnMobile;
        const baseProps = {
            activeTabId: this.activeTabId,
            onTabChange: (id)=>this.onTabSelected(id),
            showFriends: !this.isPopup && !this.hiddenTabs.has(ProfilePageTabId.Friends),
            showSettings: !this.isPopup && !this.hiddenTabs.has(ProfilePageTabId.Settings)
        };
        if (isMobile) {
            this.tabsView.render({
                ...baseProps,
                layoutMode: 'controlled',
                direction: 'horizontal',
                hideText: true
            });
            return;
        }
        this.tabsView.render({
            ...baseProps,
            direction: 'vertical'
        });
    }
    hasMadeApiCall(tabId) {
        return this.apiCallsMade.has(tabId);
    }
    markApiCallMade(tabId) {
        this.apiCallsMade.add(tabId);
    }
    setTabVisible(tabId, visible) {
        if (visible) this.hiddenTabs.delete(tabId);
        else this.hiddenTabs.add(tabId);
        this.renderTabs();
    }
    showSection(tabId) {
        const isSelfOnlyTab = tabId == ProfilePageTabId.Friends || tabId == ProfilePageTabId.Settings;
        if (isSelfOnlyTab && !this.isCurrentUserProfile()) tabId = ProfilePageTabId.Overview;
        this.sectionsByTabId.forEach((section, sectionTabId)=>{
            section.classList.toggle('hidden', sectionTabId != tabId);
        });
        this.activeTabId = tabId;
        this.renderTabs();
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        const isProfilePage = window.location.pathname.includes('/profile');
        if (!isProfilePage) return;
        history.replaceState(null, '', window.location.pathname + window.location.search + `#${tabId}`);
    }
    showSectionFromHash() {
        const hash = window.location.hash.replace('#', '');
        if (hash == '') return false;
        for (const tabId of this.sectionsByTabId.keys()){
            if (tabId == hash) {
                this.showSection(tabId);
                return true;
            }
        }
        return false;
    }
    setUsername(username) {
        this.username = username;
    }
    isCurrentUserProfile() {
        var _ClientUserState_userState;
        return ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username.toLowerCase()) == decodeURIComponent(this.username.toLowerCase());
    }
    async genericApiCallWrapper(tabId, endpoint, callback) {
        if (this.hasMadeApiCall(tabId)) return;
        const response = await UIAjaxWrapper.getRequestHandler(endpoint, undefined);
        if (response == undefined) return;
        if (!response.isSuccess) return;
        const items = response.json;
        callback(items);
        this.markApiCallMade(tabId);
    }
    resetApiCalls() {
        this.apiCallsMade.clear();
    }
    constructor(isPopup = false, username = '', onTabSelected = ()=>undefined){
        this.activeTabId = ProfilePageTabId.Overview;
        this.apiCallsMade = new Set();
        this.hiddenTabs = new Set();
        this.isPopup = isPopup;
        this.username = username;
        this.onTabSelected = onTabSelected;
        const sectionIdByTab = new Map([
            [
                ProfilePageTabId.Overview,
                'overview-container'
            ],
            [
                ProfilePageTabId.Ranked,
                'ranked-container'
            ],
            [
                ProfilePageTabId.History,
                'game-history-container'
            ],
            [
                ProfilePageTabId.Items,
                'items-container'
            ],
            [
                ProfilePageTabId.Friends,
                'friends-container'
            ],
            [
                ProfilePageTabId.Settings,
                'settings-container'
            ]
        ]);
        const popupTabIds = [
            ProfilePageTabId.Overview,
            ProfilePageTabId.Ranked,
            ProfilePageTabId.History,
            ProfilePageTabId.Items
        ];
        const tabIds = isPopup ? popupTabIds : Array.from(sectionIdByTab.keys());
        this.sectionsByTabId = new Map(tabIds.map((tabId)=>{
            const elementId = getProfilePopupElementId(sectionIdByTab.get(tabId), isPopup);
            return [
                tabId,
                document.getElementById(elementId)
            ];
        }));
        this.mountReactSidebar();
    }
}
